// store.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers/rootReducer";
import { save, load } from "redux-localstorage-simple";

const store = configureStore({
  reducer: rootReducer,
  preloadedState: load(),

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(save()),

  devTools: process.env.NODE_ENV !== "production",
});

export default store;
